import AuthForm from "./AuthForm";
import { string } from "yup";
import { useTranslation } from "react-i18next";
import { Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function ConfirmSignUpForm({apiErrors, onSubmit, resendConfirmation}) {
  const {t} = useTranslation('translation', {keyPrefix: 'form'});
  const [timer, setTimer] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
      else {
        clearInterval(interval);
      }
    }, 1000);
  
    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const formFields = [
    {id: 'code', type: 'text', autoComplete: 'off'},
  ];

  const yup = {
    code: string().required()
  };

  const resendHandler = () => {
    setTimer(30);
    resendConfirmation();
  }
  
  return (
    <AuthForm apiErrors={apiErrors} fields={formFields} onSubmit={onSubmit} onSubmitLabel={t('confirmSignUp')} yup={yup}>
      <Form.Text className='text-muted m-0'>
        <Button className='w-auto p-0' variant="link" type="button" onClick={resendHandler} disabled={timer !== 0}>
          {timer === 0 ? t('resendConfirmation') : t('countdown', {remaining: timer})}
        </Button>
      </Form.Text>
    </AuthForm>
  );
}